import picone from '../assets/png/WebsiteVisualBuild.png'
import pictwo from '../assets/png/WebsiteDevelopment.png'
import picthree from '../assets/png/WebsiteMockup.png'
import picfour from '../assets/png/UIUXDesign.png'
import picfive from '../assets/png/PrintLabel.png'
import picsix from '../assets/png/MarketingCommercial.png'


export const projectsData = [
    {
        id: 1,
        projectName: 'Website Visual Build',
        projectDesc: 'Led visual rebuild, focusing on enhancing the overall aesthetic with custom-designed images created in Canva. Utilized Squarespace to implement a modern, cohesive design that improved user experience and aligned with the brand’s identity.',
        tags: ['Squarespace','Canva'],
        code: '',
        demo: 'https://vee.llc/',
        image: picone
    },
    {
        id: 2,
        projectName: 'Website Development',
        projectDesc: 'Built a responsive WordPress site featuring Stripe-based membership sign-ups, an embedded Google Calendar, photo carousel, online pro shop, and a Google electronic signature form. Optimized for speed, security, and mobile usability.',
        tags: ['WordPress', 'Google Workspace'],
        code: '',
        demo: 'https://day-dinking.com/',
        image: pictwo
    },  
    {
        id: 3,
        projectName: 'Website Mockup',
        projectDesc: 'Website mockup created in Canva for a Philly cheesesteak food truck, emphasizing modern, responsive design for improved user experience. The design features a clean layout, optimized imagery, and a cohesive color palette to enhance brand identity and boost customer engagement.',
        tags: ['Canva'],
        code: '',
        demo: 'https://willysphillys.com/',
        image: picthree
    },
    {
        id: 4,
        projectName: 'UI/UX Design',
        projectDesc: 'Visual design created for a custom Squarespace website, focusing on layout, color scheme, typography, and overall aesthetics to align with the brand\'s identity. Delivered a polished, visually engaging site tailored to the client\'s vision.',
        tags: ['Squarespace', 'Canva'],
        code: '',
        demo: 'https://www.themindfulbreathingprogram.com/',
        image: picfour
    },
    {
        id: 5,
        projectName: 'Print Label Design',
        projectDesc: 'Created in Canva, this bold, shelf-ready label blends modern design with strong branding to stand out on store shelves. Focused on clean visuals, clear messaging, and an eye-catching aesthetic.',
        tags: ['Canva'],
        code: '',
        demo: 'https://drive.google.com/file/d/1anj3mrRS76YaBmBU2vT-I9Q8MFLgwF4i/view?usp=sharing',
        image: picfive
    },
    
    {
        id: 6,
        projectName: 'Marketing Commercial',
        projectDesc: 'Produced a sleek commercial showcasing modern cabinetry, blending clean visuals with dynamic audio to highlight product quality. Created using Canva, focusing on pacing, sound design, and smooth transitions to elevate brand presence.',
        tags: ['Canva'],
        code: '',
        demo: 'https://drive.google.com/file/d/1TumrcSQz8SmeMfzQZuhnH9IOx6DQwgyo/view?usp=sharing',
        image: picsix
    }
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/